export let myRendeImage = {
  methods: {
    imageData(data) {
      const imageDefault = require("@/assets/img/brand/no-image.jpg")
      if (data) {
        let vm = data.indexOf('public');
        if (vm !== -1) {
          let baseUrl = "";
          if (
            process.env.NODE_ENV === "production" &&
            process.env.VUE_APP_API_URL
          ) {
            baseUrl = process.env.VUE_APP_API_URL;
          } else {
            baseUrl = "http://localhost:8000";
          }
          let ImageData = `${baseUrl}/${data.replace("public/", "storage/")}`
          return this.checkImage(ImageData) ? ImageData : imageDefault;
        }
        else {
          return `https://s3.eu-west-3.amazonaws.com/app.m2m-app.com/${data}`
        }
      } else {
        return imageDefault
      }
    },
    checkImage(image) {
      return image.onerror ? 1 : 0
    }
  }
}